module.exports = __webpack_public_path__ + "static/media/KinnonTatum.aaf79027.jpg";